/* VIDA - Agregar al carrito (AJAX) con estados, microinteraccion y manejo de errores.
   Uso: <button data-vida-add data-variant-id="123" data-qty-for="#id-del-input">...</button>
   Se apoya en el carrito lateral de Dawn (cart-drawer) para abrirlo y refrescarlo. */
(function () {
  'use strict';

  // Textos editables: vienen de window.vidaStrings (Editar idioma del tema); el ultimo argumento es el respaldo
  function T(path, vars, fallback) { return (window.vidaT && window.vidaT(path, vars)) || fallback; }

  var toastEl, toastTimer;
  function toast(msg, type) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'v-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.className = 'v-toast v-toast--' + (type || 'ok');
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-in'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-in'); }, 3600);
  }

  function drawer() { return document.querySelector('cart-drawer'); }

  function sectionsToRender() {
    var d = drawer();
    return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : [];
  }

  /* Microinteraccion: el producto recien agregado se destaca dentro del carrito y aparece un aviso con check */
  function markAdded(item, added) {
    var d = drawer(); if (!d) return;
    var note = d.querySelector('[data-drawer-added]');
    if (note) {
      var txt = note.querySelector('[data-drawer-added-text]');
      var q = Number(added) || 1;
      var nm = item.product_title || item.title;
      if (txt) txt.textContent = q > 1 ? T('cart.added_qty', { qty: q, title: nm }, q + ' × ' + nm + ' agregado al carrito') : T('cart.added', { title: nm }, nm + ' agregado al carrito');
      note.hidden = false;
      note.classList.remove('is-in'); void note.offsetWidth; note.classList.add('is-in');
    }
    var input = d.querySelector('[data-quantity-variant-id="' + item.variant_id + '"]');
    var row = input && input.closest('.cart-item');
    if (row) {
      row.classList.add('is-just-added');
      setTimeout(function () { row.classList.remove('is-just-added'); }, 2600);
    }
  }
  function bumpCartIcon() {
    var icon = document.querySelector('#cart-icon-bubble');
    if (!icon) return;
    icon.classList.remove('v-bump'); void icon.offsetWidth; icon.classList.add('v-bump');
  }

  function add(variantId, qty, props) {
    var body = { id: Number(variantId), quantity: Number(qty) || 1 };
    var ids = sectionsToRender();
    if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
    if (props) body.properties = props;
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, status: r.status, json: j }; });
    });
  }

  function setState(btn, state, label) {
    var span = btn.querySelector('[data-label]');
    if (!btn._orig && span) btn._orig = span.textContent;
    btn.classList.remove('is-loading', 'is-done');
    if (state === 'loading') btn.classList.add('is-loading');
    if (state === 'done') { btn.classList.add('is-done'); if (span) span.textContent = label || T('cart.done', null, 'Agregado'); }
    if (state === 'idle' && span && btn._orig) span.textContent = btn._orig;
    btn.disabled = state === 'loading';
    btn.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vida-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var qtyEl = btn.getAttribute('data-qty-for') ? document.querySelector(btn.getAttribute('data-qty-for')) : null;
    var qty = qtyEl ? qtyEl.value : (btn.getAttribute('data-qty') || 1);
    var variant = btn.getAttribute('data-variant-id');
    var vSel = btn.getAttribute('data-variant-source') ? document.querySelector(btn.getAttribute('data-variant-source')) : null;
    if (vSel && vSel.value) variant = vSel.value;
    if (!variant) return toast(T('cart.error_variant', null, 'No pudimos identificar el producto. Recarga la pagina e intenta de nuevo.'), 'error');

    setState(btn, 'loading');
    add(variant, qty).then(function (res) {
      if (!res.ok) {
        setState(btn, 'idle');
        var msg = res.json && (res.json.description || res.json.message);
        return toast(msg || T('cart.error_add', null, 'No pudimos agregar el producto. Intenta de nuevo.'), 'error');
      }
      setState(btn, 'done', btn.getAttribute('data-done-label') || T('cart.done', null, 'Agregado'));
      var d = drawer();
      if (d && d.renderContents && res.json.sections) {
        d.classList.remove('is-empty');
        d.renderContents(res.json);
        setTimeout(function () { markAdded(res.json, qty); }, 60);
      } else toast(T('cart.toast_added', null, 'Agregado al carrito'), 'ok');
      bumpCartIcon();
      document.dispatchEvent(new CustomEvent('vida:cart-added', { detail: res.json }));
      setTimeout(function () { setState(btn, 'idle'); }, 2200);
    }).catch(function () {
      setState(btn, 'idle');
      toast(T('cart.error_network', null, 'Parece que no hay conexion. Revisa tu internet e intenta de nuevo.'), 'error');
    });
  });

  /* La entrada escalonada de los productos solo corre al abrir el carrito, no en cada cambio de cantidad */
  function watchDrawer() {
    var d = drawer(); if (!d || !window.MutationObserver) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      /* Solo se toca la clase si de verdad cambia: add/remove sin cambio igual dispara este mismo observador y congela la pagina en un bucle */
      if (d.classList.contains('active')) { t = setTimeout(function () { if (!d.classList.contains('v-settled')) d.classList.add('v-settled'); }, 1500); }
      else if (d.classList.contains('v-settled')) d.classList.remove('v-settled');
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer); else watchDrawer();

  window.VidaCart = { add: add, toast: toast };
})();
